export class RouteFilterConstants {
    public static queryParamsHandlingMerge: any = 'merge';
}